import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../bootstrap/bootstrap-5.3.3-dist/css/bootstrap.min.css";
import CV from '../images/Sami_Muhammed_CV (2).pdf';
import logo from "../images/logo.png";
// import "../personalPage/courseHeaderLogin.css"; // ✅ reuse same CSS for consistency

function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState(location.pathname);
  const navRef = useRef(null);

  // ✅ Sticky header on scroll
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".headerLogin");
      header?.classList.toggle("scrolled", window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ✅ Close menu when clicking outside
  useEffect(() => {
    const closeMenu = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener("mousedown", closeMenu);
    return () => document.removeEventListener("mousedown", closeMenu);
  }, []);

  // ✅ Scroll to section
  const handleScrollToSection = (hash) => {
    if (location.pathname !== "/") {
      navigate(`/${hash}`);
      setTimeout(() => {
        const section = document.querySelector(hash);
        section?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    } else {
      const section = document.querySelector(hash);
      section?.scrollIntoView({ behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  const navItems = [
    { label: t("Home"), path: "/" },
    { label: t("About"), path: "#about" },
    { label: t("Courses"), path: "/courses" },
    { label: t("Contact"), path: "#contactUs" },
  ];

  return (
    <header className="headerLogin shadow-sm" style={{position:"fixed" , width:"100%" ,background:"#111"}}>
      <nav className="navbar navbar-expand-lg navbar-dark w-100" ref={navRef}>
        <div className="container-fluid">
          {/* ✅ Logo */}
          <div
            className="d-flex align-items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img src={logo} alt="Logo" id="headerLogo" className="me-2" />
          </div>

          {/* ✅ Toggle Button */}
          <button
            className="navbar-toggler border-0 p-2"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpen((prev) => !prev);
            }}
          >
            {menuOpen ? <FaTimes size={26} /> : <FaBars size={26} />}
          </button>

          {/* ✅ Menu */}
          <div
            className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
            id="navbarMenu"
            style={{
              backdropFilter: menuOpen && "blur(10px)",
              position: menuOpen ? "fixed" : "relative",
              top: menuOpen ? 120 : 0,
              left: 0,
              width: menuOpen ? "100%" : "auto",
              zIndex: menuOpen ? 1050 : "auto",
              padding: menuOpen ? "30px" : "0",
            }}
          >
            <ul className="navbar-nav mx-auto text-center my-3 my-lg-0 gap-lg-4">
              {navItems.map((item, index) => (
                <li
                  key={index}
                  className={`nav-item ${activeLink === item.path ? "active" : ""}`}
                >
                  {item.path.startsWith("#") ? (
                    <a
                      href={item.path}
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handleScrollToSection(item.path);
                      }}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      className="nav-link"
                      to={item.path}
                      onClick={() => {
                        setActiveLink(item.path);
                        setMenuOpen(false);
                      }}
                    >
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>

            {/* ✅ CV Button */}
            <div className="text-center">
              <a 
                href={CV} 
                download="Sami_Muhammed_CV.pdf" // هذا الاسم هو ما سيظهر للمستخدم عند التحميل
                className="btn auth-btn"
                style={{
                  padding: "12px 30px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  letterSpacing: "1px",
                  transition: "0.3s"
                }}
              >
                DOWNLOAD CV <i className="fa-solid fa-download ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
